import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";

import { COUPON_INFORMATION } from "@/shared/resource/constants";
import { COUPON } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";

export const useCouponStore = defineStore("coupon", {
  state: () => ({
    couponsList: {
      list: [],
      totalCount: 0,
      info: [...COUPON_INFORMATION],
    },
  }),

  actions: {
    clearCouponsList() {
      this.couponsList.list = [];
      this.couponsList.totalCount = 0;
    },

    async deleteCoupon(id) {
      const response = await api.delete(COUPON.DELETE(id));
      return response.data;
    },

    async getCouponDetails(id) {
      const response = await api.get(COUPON.GET(id));
      return response.data;
    },

    async fetchCoupons({ page = 1, limit = 10, filters = {} }) {
      this.clearCouponsList();

      const response = await api.get(COUPON.LIST, { params: { page_no: page, count: limit, ...filters }});
      const data = response?.data?.data || [];

      const formattedEntities = data.map((coupan) => ({
        uuid: coupan.id,
        id: coupan.coupan_id,
        couponCode: coupan.coupan_code || "-",
        createdAt: dateTime.formatDateTime(coupan.created_at),
        couponType: coupan.coupan_type || "-",
        discount:
          coupan.discount_value !== undefined
            ? `${coupan.discount_value}${
                coupan.coupan_type === "percentage" ? "%" : ""
              }`
            : "-",
        validDays: coupan.valid_day !== undefined ? `${coupan.valid_day} day(s)` : "-",
        minimumFare: coupan.min_fare !== undefined ? `₹${coupan.min_fare}` : "-",
        createdBy: coupan.created_by,
        usedCount: coupan.used_count,
        status: coupan.is_active,
      }));

      this.setCouponsList(formattedEntities, response?.data?.total_count || 0, response?.data);
      return formattedEntities;
    },

    async updateCoupon(id, payload) {
      const response = await api.put(COUPON.UPDATE(id), payload);
      return response;
    },

    async addCoupon(payload) {
      const response = await api.post(COUPON.CREATE, payload);
      return response;
    },

    async save(id, payload) {
      const { couponCode, couponType, couponValue, minimumFare, validDays, createdBy } = payload;

      const formattedPayload = {
        coupan_code: couponCode,
        coupan_type: couponType,
        discount_value: Number(couponValue),
        min_fare: Number(minimumFare),
        valid_day: Number(validDays),
        created_by: createdBy,
      };

      let response;
      if (id) {
        response = await this.updateCoupon(id, formattedPayload);
      } else {
        response = await this.addCoupon(formattedPayload);
      }
      return response.data;
    },

    setCouponsList(coupons, total, info) {
      this.couponsList.list = coupons;
      this.couponsList.totalCount = total;
      if (info) {
        this.couponsList.info[0].count = info.total_count;
        this.couponsList.info[1].count = info.active_count;
        this.couponsList.info[2].count = info.total_value_Of_coupans_used;
      }
    },
  },

  getters: {
    getCouponsList: (state) => state.couponsList,
  },
});
